/**
 * Admin Dashboard shared types.
 */

export interface Scan {
  id: string;
  name: string;
  fullName: string;
  url: string;
  platform: string;
  owner: string;
  language: string | null;
  overallScore: number | null;
  grade: string | null;
  scoreDrift: number | null;
  significantDrift: boolean;
  analyzedAt: string | null;
  analysisId: string | null;
  scannedBy: { id: string; email: string; name: string } | null;
  createdAt: string;
}

export interface Task {
  id: string;
  taskClass: string;
  category: string;
  status: string;
  phase: string | null;
  startedAt: string | null;
  completedAt: string | null;
  prUrl: string | null;
  error: string | null;
  user: { id: string; email: string; firstName: string } | null;
  repository: { id: string; name: string; fullName: string } | null;
}

export interface MtEntry {
  taskClass: string;
  displayName: string;
  description: string | null;
  icon: string | null;
  priority: string;
  category: string | null;
  keywords: string[];
}

export interface Pagination {
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
}

export type Tab = 'scans' | 'tasks' | 'mt';

export const PAGE_SIZE = 25;
export const MT_PAGE_SIZE = 10;
